export const getAdminModuleTitle = (accesses: UserModel.AccessesApiData['accesses'], tag: UserModel.ModuleTag): string => {
  const module = accesses?.find?.((access) => access.module.tag === tag)?.module
  const { title, customSettings } = module || {}
  const { title: customTitle } = customSettings || {}

  return module?.customTitle || customTitle || title
}

export default getAdminModuleTitle